export const AUTOPOP_HIGHLIGHT = 'ML: Autopopulate'
export const DATA_TEST_ID_PREFIX = 'highlight-'
export const LEADER_HIGHLIGHT = 'ML: Leader'
